import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import MarkAsReadOrUnread from '../MarkAsReadOrUnread/MarkAsReadOrUnread';
import { Icon } from 'components';
import styles from './NotificationItem.scss';

const NotificationItem = ({
  notification,
  close,
  action,
  taskItemAction,
  notificationData,
  staticTexts,
  onClickMarkAsRead,
  children,
  taskCardTitle,
  isTaskItem
}) => {
  const handleClick= () => {
    if (isTaskItem) {
      taskItemAction(notification.data.cardId, notification.data.taskId, notification.id)
    } else {
      action('', notification.data.requestId, notification.id);
    }
    close();
  };

  return (
    <div
      onClick={handleClick}
      className={classnames(
        styles.notificationsItem,
        styles[notification.data.status],
        {[styles.unseen]: !notification.seen},
      )}
      data-testid={`alerts-popOver__alert-${notification.id}`}
    >
      <div className={styles.notificationHeader}>
        {
          isTaskItem ?
          <div className={styles.taskCardTitle}>
            <Icon name='ion-md-checkmark-circle-outline' className={styles.taskIcon}/>
            <div className={styles.notificationTitle}>{taskCardTitle}</div>
          </div>
          :
          <div className={styles.notificationTitle}>{notification.data.title}</div>
        }
        
        <div className={styles.date}>{notification.createdAt}</div>
      </div>
      {children}
      <MarkAsReadOrUnread
        markAsReadStyle={styles.markAsRead}
        notification={notification}
        staticTexts={staticTexts}
        onClickMarkAsRead={onClickMarkAsRead}
      />
      { notification.data.hasMessage &&
        <div className={styles.replyMessage}>
          <Icon name='ion-md-chatboxes' className={styles.messageIcon}/>
          <b>{notification.data.author}</b>&nbsp;{ notificationData.changedStatus.messageStaticText }
        </div>
      }
    </div>
  );
};

NotificationItem.propTypes = {
  notification: PropTypes.shape({
    createdAt: PropTypes.string,
    type: PropTypes.string,
    seen: PropTypes.bool,
    data: PropTypes.object,
  }).isRequired,
  close: PropTypes.func.isRequired,
  action: PropTypes.func.isRequired,
  notificationData: PropTypes.shape({
    changedStatus: PropTypes.shape({
      requestStatusStaticText: PropTypes.string,
      messageStaticText: PropTypes.string,
    })
  }).isRequired,
  children: PropTypes.node,
  staticTexts: PropTypes.shape({
    markAsRead: PropTypes.string,
    markAsUnread: PropTypes.string,
  }).isRequired,
  onClickMarkAsRead: PropTypes.func.isRequired,
  taskCardTitle: PropTypes.string,
  isTaskItem: PropTypes.bool
};

NotificationItem.defaultProps = {
  taskCardTitle: '',
  isTaskItem: false
}

export default NotificationItem;
